var _a;
var marker = Symbol();
/**
 *  The request
 *
 * @export
 * @template T
 */
// eslint-disable-next-line @typescript-eslint/no-empty-interface,  @typescript-eslint/no-unused-vars
var RequestData = /** @class */ (function () {
    function RequestData() {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this[_a] = null; // It has there otherwise type inference doesn't work.
    }
    return RequestData;
}());
export default RequestData;
_a = marker;
//# sourceMappingURL=requestData.js.map